/**
 * Subscribe to Zustand persist rehydration for the canonical workspace store.
 *
 * Calling `persist.hasHydrated()` during render alone does not schedule a
 * re-render when hydration finishes with the same selector value (e.g.
 * activeWorkspaceId stays null). This hook forces a re-render via
 * onFinishHydration so route gates never decide on an in-flight null.
 */
import { useEffect, useState } from "react";

import { useWorkspaceStore } from "@/state/workspace.store";

export function useWorkspacePersistHydrated(): boolean {
  const [hydrated, setHydrated] = useState(() => {
    const persist = useWorkspaceStore.persist;
    if (!persist?.hasHydrated) return true;
    return persist.hasHydrated();
  });

  useEffect(() => {
    const persist = useWorkspaceStore.persist;
    if (!persist?.hasHydrated) {
      setHydrated(true);
      return;
    }

    if (persist.hasHydrated()) {
      setHydrated(true);
      return;
    }

    const unsub = persist.onFinishHydration(() => {
      setHydrated(true);
    });
    return unsub;
  }, []);

  return hydrated;
}
